import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { View } from 'react-native';

import { factory } from '../positions/asset-position/asset-position-container';
import AssetItem from '../../../components/asset/asset-item';
import {
  AssetItemHeaderDescription,
  AssetItemHeaderChange,
} from '../../../components/asset/asset-item/asset-item-header';
import {
  AssetItemDataChange,
} from '../../../components/asset/asset-item/asset-item-data';

import TableRow from '../../../components/common/table-row';

import { Percent } from '../../../components/common/number';

import {
  AbbreviatedNumber,
} from '../../../components/common/number';



import defaultStyles from '../positions/asset-position/asset-position.styles';
import styles from './alternatives-asset-position.styles';

class AlternativesAssetPosition extends PureComponent {
  static propTypes = {
    row: PropTypes.shape({
      security: PropTypes.shape({ name: PropTypes.string }),
      quantity: PropTypes.number,
      marketValue: PropTypes.number,
      unrealisedGL: PropTypes.number,
      unrealisedGLPercent: PropTypes.number,
      proportion: PropTypes.number,
      priceDate: PropTypes.string,
    }),
    columnWidths: PropTypes.arrayOf(PropTypes.number).isRequired,
    screen: {
      isSmall: PropTypes.bool,
    },
  };

  static defaultProps = {
    row: {},
    screen: {
      isSmall: false,
    },
  };

  getCenterColumnComponent(value, date) {
    return (
      <View style={styles.marketValueView}>
        <AbbreviatedNumber
          renderProps={{ size: 'large' }}
          maxDigits={10}
          value={value}
        />
        {/*<SimpleDate
          renderProps={{
            size: 'small',
            disabled: true,
          }}
          value={date}
        />*/}
      </View>
    );
  }

  render() {
    const { row, columnWidths, screen } = this.props;
    const {
      security,
      quantity,
      marketValue,
      unrealisedGL,
      unrealisedGLPercent,
      proportion,
      priceDate,
      isin,
    } = row;
    var shorten = false;

    if (screen.isSmall) {
      shorten = 30;
    }

    return (
      <AssetItem>
        {
          screen.isSmall &&
          <View>
            <TableRow style={defaultStyles.topRow}>
              <TableRow.Column
                align="left"
                width={columnWidths[0] + columnWidths[1]}
                testID="description"
              >
                <AssetItemHeaderDescription
                  row={{
                    description: security,
                  }}
                  shorten={shorten}
                />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemHeaderChange value={unrealisedGLPercent} />
              </TableRow.Column>
            </TableRow>
            <TableRow style={defaultStyles.bottomRow}>
              <TableRow.Column
                align="left"
                width={columnWidths[0]}
              >
                <AbbreviatedNumber
                  renderProps={{ size: 'large' }}
                  maxDigits={6}
                  maxDecimals={4}
                  maxDigitsIncludeDecimals={true}
                  value={quantity}
                />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[1]}>
                {this.getCenterColumnComponent(marketValue, priceDate)}
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemDataChange value={unrealisedGL} />
              </TableRow.Column>
            </TableRow>
          </View>
        }
        {
          !screen.isSmall &&
          <View>
            <TableRow style={defaultStyles.topRow}>
              <TableRow.Column
                align="left"
                width={columnWidths[0] + columnWidths[1]}
                testID="description"
              >
                <AssetItemHeaderDescription
                  row={{
                    description: security,
                  }}
                />
              </TableRow.Column>

            </TableRow>
            <TableRow style={defaultStyles.bottomRow}>
              <TableRow.Column
                align="left"
                width={columnWidths[0]}
              >
                <AbbreviatedNumber
                  renderProps={{ size: 'large' }}
                  maxDigits={6}
                  maxDecimals={4}
                  maxDigitsIncludeDecimals={true}
                  value={quantity}
                />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[1]}>
                {this.getCenterColumnComponent(marketValue, priceDate)}
              </TableRow.Column>
              <TableRow.Column width={columnWidths[2]}>
                <AssetItemDataChange value={unrealisedGL} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[3]}>
                <AssetItemHeaderChange value={unrealisedGLPercent} />
              </TableRow.Column>
              <TableRow.Column width={columnWidths[4]}>
                <Percent value={proportion} />
              </TableRow.Column>
            </TableRow>
          </View>
        }
      </AssetItem>
    );
  }
}

export default factory({
  component: AlternativesAssetPosition,
  rowFragmentExtend: {
    priceDate: true,
  }
});
